import { Link } from 'react-router';
import { UserPagePathBuilder } from '@user/pages/UserPagePathBuilder';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiagramProject, faGlobe, faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import { HighlightText } from './HighlightText';
import { classNames } from '@framework/utils';
import type { ViewModelId } from 'balus-common';

type Props = {
  viewModelId: ViewModelId;
  isViewModelPublicReadable: boolean;
  isIndividualPermissionConfigured: boolean;
  isLocked: boolean;
  viewModelName: string;
  searchKeyword?: string;
  isExternal?: boolean;
};

export const ViewModelItemTitle: React.FC<Props> = ({
  viewModelId,
  isViewModelPublicReadable,
  isIndividualPermissionConfigured,
  isLocked,
  viewModelName,
  searchKeyword,
  isExternal = false,
}: Props) => {
  return (
    <Link
      to={UserPagePathBuilder.viewModelPage(viewModelId)}
      className={classNames('flex min-w-0 items-center rounded-sm py-1 pr-1')}
      {...(isExternal && { target: '_blank', rel: 'noopener noreferrer' })}
    >
      <span className="fa-layers fa-fw mr-1 shrink-0 text-brand">
        {isViewModelPublicReadable ? (
          <>
            <FontAwesomeIcon icon={faDiagramProject} transform="shrink-2 top-3 left-1" />
            <FontAwesomeIcon icon={faGlobe} transform="shrink-8 down-3 right-7" />
          </>
        ) : isIndividualPermissionConfigured ? (
          <>
            <FontAwesomeIcon icon={faDiagramProject} transform="shrink-2 top-3 left-1" />
            <FontAwesomeIcon icon={faUser} transform="shrink-8 down-3 right-7" />
          </>
        ) : (
          <FontAwesomeIcon icon={faDiagramProject} />
        )}
      </span>
      {isLocked && (
        <span className="fa-layers fa-fw mr-1 shrink-0 text-brand">
          <FontAwesomeIcon icon={faLock} />
        </span>
      )}
      <HighlightText className="truncate" text={viewModelName} keyword={searchKeyword || ''} />
    </Link>
  );
};
